import { MemberCompanies } from '@/components/MemberCompanies';
import { RouteRestrictions } from '@/utilities';
import { restrictedRoute } from '@/utilities/restrictedRoute';

export default restrictedRoute(MemberCompanies, {
  requiresEvery: [RouteRestrictions.MEMBER_DIRECTORY_ACCESS],
});
